import processConstants from './process-constants';
import sortArrayByPriority from '../../utils/sorting/sortArrayByPriority';

const handleConsts = (state, action) => {
  const { payload } = action;

  // lead given data to a standard needed on front form
  const processedConsts = processConstants(payload);

  // change initial gender types sorting according to types priority
  const { genderTypes } = processedConsts;
  const priority = ['f', 'm'];
  processedConsts.genderTypes = sortArrayByPriority(genderTypes, priority);

  return processedConsts;
};

export default handleConsts;



// WEBPACK FOOTER //
// ./src/redux/data/handle-constants.js